<div class="dialog-viewer">
    <h2 mat-dialog-title>Edit Addon</h2>
    <form [formGroup]="form" (ngSubmit)="submit(form)">
        <mat-dialog-content>
            <div class="container-fluid">
                <div class="row">
                    <div class="col">
                        <mat-form-field>
                            <mat-label>Name</mat-label>
                            <input matInput required name="name" id="name" placeholder="Name" type="text"
                                formControlName="name" />
                            <mat-error *ngIf="form.get('name').errors?.required">Name is required
                            </mat-error>
                            <mat-error *ngIf="form.get('name').errors?.validationErrors">
                                {{ form.get("name").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field>
                            <mat-label>Description</mat-label>
                            <input required matInput name="description" id="description" placeholder="Description"
                                type="text" formControlName="description" />
                            <mat-error *ngIf="form.get('description').errors?.required">Description is required
                            </mat-error>
                            <mat-error *ngIf="form.get('description').errors?.validationErrors">
                                {{ form.get("description").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field>
                            <mat-label>Price</mat-label>
                            <span matTextPrefix>$ &nbsp;</span>
                            <input required matInput name="price" id="price" placeholder="Price" type="number"
                                formControlName="price" />
                            <mat-error *ngIf="form.get('price').errors?.required">Price is required
                            </mat-error>
                            <mat-error *ngIf="form.get('price').errors?.validationErrors">
                                {{ form.get("price").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="text-center">
                <button mat-raised-button type="submit" [disabled]="isLoading">Save</button>
                <button mat-raised-button (click)="dialogRef.close('cancel')" color="warn"
                    [disabled]="isLoading">Cancel</button>
            </div>
        </mat-dialog-actions>
    </form>
</div>
